
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { setActiveAction} from '@process-advisor/process-miner/processMiner/processMiner'

export type Props = ApiMethodBase & {}

export const setAction_Findings = ({ eventEmitter }: Props) => {
    setActiveAction('findings')
    eventEmitter.emit(Event.setActionBar_Findings);
};

